"use client";

import type { FC, Ref } from "react";

export interface NextTaskCardTemplateProps {
  title: string;
}

/**
 * A template for next task card functionality
 */
export const NextTaskCardTemplate: FC<
  NextTaskCardTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ ref, ...props }) => <div ref={ref} {...props} />;
